// extracted by mini-css-extract-plugin
module.exports = {"feedback":"Feedback-module--feedback--yvqI9","title":"Feedback-module--title--3z2Ve","error":"Feedback-module--error--1K9Wz"};